// extracted by mini-css-extract-plugin
export default {"responsiveContainer":"dashboard_responsiveContainer__MaNwq"};